import { render, staticRenderFns } from "./spaceUsage.vue?vue&type=template&id=7b10de16&"
import script from "./spaceUsage.vue?vue&type=script&lang=js&"
export * from "./spaceUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports